/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useMemo, FC, useEffect } from "react";
import { Popover, Transition } from "@headlessui/react";
import cls from "clsx";
import Icon from "@ht/shared/fonts/deos-pis/slider";
import FilterValue from "./FilterValue";

interface IProps {
    data: any;
    selected: any[];
    onClear(result: boolean): void;
    onFilter(result: any[]): void;
    showIconOnly?: boolean;
    className?: string;
}

const ButtonFilter: FC<IProps> = ({
    data,
    selected,
    onClear,
    onFilter,
    className,
    showIconOnly = false,
}) => {
    const [filters, setFilters] = useState<any[]>(selected);
    const [tempFilters, setTempFilters] = useState<any[]>(selected);
    const [isClearFilter, setIsClearFilter] = useState(false);

    useEffect(() => {
        setFilters(selected);
    }, [selected])

    const filterData = useMemo(() => {
        const result: any[] = [];
        data.map((filter: { key: { value: any }; data: any }) => {
            const index = result.findIndex(
                (f) => f.key.value === filter.key.value
            );
            if (index > -1) {
                result[index].values.push(filter.data);
            } else {
                result.push({ key: filter.key, values: [filter.data] });
            }
        });

        return result;
    }, [data]);

    const handleSelect = (e: { key: any; value: any }) => {
        const isExist =
            tempFilters.findIndex(
                (x: { key: any; value: any }) =>
                    x.key === e.key && x.value === e.value
            ) > -1;

        if (!isExist) setTempFilters([...tempFilters, e]);

        setIsClearFilter(false);
    };

    const handleDeselect = (e: { key: any; value: any }) => {
        if (tempFilters.length > 0) {
            const isSelected = tempFilters.filter(
                (x) => x.key === e.key && x.value === e.value
            ).length;
            if (isSelected) {
                const filtered = tempFilters.filter(
                    (x) => x.key !== e.key || x.value !== e.value
                );
                setTempFilters(filtered);
            }
        }
    };

    const handleFilter = () => {
        const filterResult: any[] = [];

        tempFilters.map((filter) => {
            const index = filterResult.findIndex((f) => f.key === filter.key);

            if (index > -1) {
                filterResult[index].values.push(filter.value);
            } else {
                filterResult.push({
                    key: filter.key,
                    values: [filter.value],
                });
            }
        });
        setFilters(filterResult);
        onFilter(filterResult);
    };

    const handleClear = () => {
        setFilters([]);
        setTempFilters([]);

        setIsClearFilter(true);
        onClear(true);
    };

    const getActive = ({ item, value }: any) => {
        return tempFilters.findIndex(
            (f) =>
                f.key ===
                item
                    .key
                    .value &&
                (f.values
                    ? f.values.includes(
                        value.value
                    )
                    : f.value ===
                    value.value)
        ) > -1
    }

    return (
        <Popover as="div" className="relative cursor-pointer">
            <Popover.Button
                as="div"
                className={cls(
                    filters.length > 0
                        ? "bg-primary"
                        : "border border-thin border-gray-200",
                    "flex items-center gap-[6px] h-[32px] rounded-md px-4 py-2 justify-center",
                    className
                )}
            >
                <Icon
                    name="sliders"
                    className={cls(
                        filters.length > 0 ? "text-white" : "text-gray-700",
                        " h-4 w-4"
                    )}
                />
                {!showIconOnly && (
                    <span
                        className={cls(
                            filters.length > 0 ? "text-white" : "text-gray-700",
                            "text-base font-bold"
                        )}
                    >
                        Filter
                    </span>
                )}
            </Popover.Button>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
            >
                <Popover.Panel
                    className="absolute md:right-0 mt-1 origin-top-right rounded-lg
             bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none w-60 z-[20]"
                >
                    {({ close }) => (
                        <>
                            <div className="px-2 py-2 overflow-y-scroll max-h-[400px]">
                                {filterData.map((item, idx) => {
                                    const key = `idx_${idx}`;
                                    return (
                                        <div key={key} className="mb-2">
                                            <p className="text-base text-gray-700 font-bold mb-2">
                                                {item.key.label}
                                            </p>
                                            <div className="flex gap-[6px] flex-wrap">
                                                {item.values.map(
                                                    (
                                                        value: {
                                                            label: any;
                                                            value: any;
                                                        },
                                                        i:
                                                            | React.Key
                                                            | null
                                                            | undefined
                                                    ) => {
                                                        const filterKey = `filter_${i}`;
                                                        return (
                                                            <FilterValue
                                                                key={filterKey}
                                                                filterKeyValue={
                                                                    item.key
                                                                        .value
                                                                }
                                                                filterDataLabel={
                                                                    value.label
                                                                }
                                                                filterDataValue={
                                                                    value.value
                                                                }
                                                                filterCount={
                                                                    tempFilters.length
                                                                }
                                                                active={
                                                                    getActive({ item, value })
                                                                }
                                                                clearSelection={
                                                                    isClearFilter
                                                                }
                                                                onSelect={
                                                                    handleSelect
                                                                }
                                                                onDeselect={
                                                                    handleDeselect
                                                                }
                                                            />
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="flex justify-between items-center p-2">
                                <div className="w-1/2 text-left">
                                    <button
                                        className="text-red-900 text-base font-semibold pl-[4px]"
                                        onClick={handleClear}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="w-1/2 text-right">
                                    <button
                                        // className="bg-purple-900 text-white text-base font-bold px-2 py-[6px] rounded-[4px]"
                                        className={cls(
                                            "bg-purple-900 text-white text-base font-bold px-2 py-[6px] rounded-[4px]"
                                        )}
                                        onClick={() => {
                                            close();
                                            handleFilter();
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </Popover.Panel>
            </Transition>
        </Popover>
    );
};

export default ButtonFilter;
